import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ValidationHelperService {
    messages: any;
    succeeded: boolean;
    status: string;
    optionsObj: any = {};

    constructor() { }

    validationInstance() {
        this.messages = [];
        this.succeeded = true;
        this.status = "";
    }

    addValidationError(message, failsValidation) {
        if (failsValidation == null) failsValidation = true;
        this.messages.push(message);
        this.status = "error";
        if (failsValidation) {
            this.succeeded = false;
        }
    }

    addValidationWarning(message) {
        this.messages.push(message);
        if (this.status != "error")
            this.status = "warning"; //Can't overwrite error with warning

        this.succeeded = false;
    }

    messagesToListItemsString() {
        var msg = "";
        for (var i = 0; i < this.messages.length; i++) {
            msg += this.messages[i] + "\n";
        }
        return msg;
    }

    convertTestAs(val, testAs) {
        if (testAs == null || val == null) return val;

        if (testAs == "Number")
            return parseFloat(val);
        if (testAs == "DateTime")
            return (Date.parse(val) == null || val == "") ? ((new Date(val) instanceof Date && !isNaN(val)) ? new Date(val) : val) : Date.parse(val);
        if (testAs == "String")
            return val.toString();
    }

    test(value, optionsObject) {
        /// <summary>Tests the val against the options set in optionsObject</summary>
        /// <param name="value" type="Anything">The value to validate</param>
        /// <param name="optionsObject" type="ConfigObject">Determines what conditions to validate. 
        /// Common fields: Required: 'message', MinValue { Minimum: number, Message: 'message' }
        /// See Utilites.js for a full list of parameters.</param>

        //If optionsObject is null, just return as nothing is available to validate
        if (optionsObject == null) return;

        //Set defaults
        //Message Chaining is allowing multiple error messages per variable to be reported.  Otherwise the first fail will be the only reported.  Default is false (only 1 per)
        optionsObject.MessageChaining = optionsObject.MessageChaining || false;

        //Local helper vars
        var val = this.convertTestAs(value, optionsObject.TestAs);
        var encounteredError = false;

        //If the field is not required and it happens to be null, return and don't check the other values as it will cause an undefined expression            
        if (optionsObject.Required == null && val == null) {
            return;
        }

        //If the optionsObject has the Required field set (meaning the length must be greater than 0)
        if (optionsObject.Required != null) {
            //if val fails the required check
            if (val == null || val.length <= 0) {
                //if an error has been encountered already or Message Chaining is allowed (see defaults for Message Chaining explanation)
                if (!encounteredError || optionsObject.MessageChaining) {
                    // if failsValidation is true, the form submission will be prevented
                    const failsValidation = optionsObject.failsValidation || val;
                    //Add message and set encounteredError to true
                    this.addValidationError(optionsObject.Required, failsValidation);
                    encounteredError = true;
                }
            }
        }

        if (optionsObject.Format != null) {
            switch (optionsObject.Format.Type) {
                case "GenericDate":
                    var parsed = new Date(value);
                    if (parsed == undefined || parsed == null || !(new Date(value) instanceof Date && !isNaN(value))) {
                        if (!encounteredError || optionsObject.MessageChaining) {
                            this.addValidationError(optionsObject.Format.Message, value);
                            encounteredError = true;
                        }
                    }
                    break;
            }
        }

        //If the optionsObject has the DigitOnly field set (meaning that only digits are allowed in the input)
        if (optionsObject.DigitOnly != null) {
            ////Old way that only works for whole numbers
            //if (!(new RegExp('^\\d+$').test(val))) {
            //    //if an error has been encountered already or Message Chaining is allowed (see defaults for Message Chaining explanation)
            //    if (!encounteredError || optionsObject.MessageChaining) {
            //        this.addValidationError(optionsObject.DigitOnly);
            //        encounteredError = true;
            //    }
            //}

            ////New way that checks virtually any number (decimal or integer)
            if (isNaN(val)) {
                //if an error has been encountered already or Message Chaining is allowed (see defaults for Message Chaining explaination)
                if (!encounteredError || optionsObject.MessageChaining) {
                    this.addValidationError(optionsObject.DigitOnly, val);
                    encounteredError = true;
                }
            }
        }

        //If the optionsObject has the whole number only field set (meaning that only whole numbers are allowed in the input)
        if (optionsObject.WholeNumberOnly != null) {
            if (!(new RegExp('^\\d+$').test(val))) {
                //if an error has been encountered already or Message Chaining is allowed (see defaults for Message Chaining explanation)
                if (!encounteredError || optionsObject.MessageChaining) {
                    this.addValidationError(optionsObject.WholeNumberOnly, val);
                    encounteredError = true;
                }
            }
        }

        //If the optionsObject has the MinValue field set (meaning that the value needs to be greater than MinValue.Minimum)
        if (optionsObject.MinValue != null) {
            var minVal = this.convertTestAs(optionsObject.MinValue.Minimum, optionsObject.TestAs);

            var minValReq = optionsObject.MinValue.Required;
            var minError = false;

            if (minValReq == null || minValReq == true) {
                if (minVal == null || val < minVal) {
                    minError = true;
                }
            } else {
                if (minVal != null && val < minVal) {
                    minError = true;
                }
            }

            if (minError) {
                //if an error has been encountered already or Message Chaining is allowed (see defaults for Message Chaining explanation)
                if (!encounteredError || optionsObject.MessageChaining) {
                    this.addValidationError(optionsObject.MinValue.Message, minVal);
                    encounteredError = true;
                }
            }
        }

        //If the optionsObject has the MaxValue field set (meaning that the value needs to be greater than MaxValue.Maximum)
        if (optionsObject.MaxValue != null) {
            var maxVal = this.convertTestAs(optionsObject.MaxValue.Maximum, optionsObject.TestAs);
            var maxValReq = optionsObject.MaxValue.Required;
            var maxError = false;

            if (maxValReq == null || maxValReq == true) {
                if (maxVal == null || val > maxVal) {
                    maxError = true;
                }
            } else {
                if (maxVal != null && val > maxVal) {
                    maxError = true;
                }
            }

            if (maxError) {
                //if an error has been encountered already or Message Chaining is allowed (see defaults for Message Chaining explanation)
                if (!encounteredError || optionsObject.MessageChaining) {
                    this.addValidationError(optionsObject.MaxValue.Message, maxVal);
                    encounteredError = true;
                }
            }
        }
    };

    /*
        OptionsObject Fields:
        TestAs (string): Converts the value and checks to this type to keep testing consistant between checks.
            Allowed Values: 
                "String" -- converts data to a string value using .toString()
                "DateTime" -- converts data to a datetime value using Date.parse(val)
                "Number" (default) --converts data to a number value using parseFloat()
  
        MessageChaining (bool): Whether or not a value should be tested and reported after a fail.  With true, all conditions that fail will be in the messages list of the validation
  
        Required (string): Message for the required check. Omit field to ignore this check.
  
        DigitOnly (string): Message for the digit only check. Omit field to ignore this check.
  
        MinValue (object): Omit field to ignore MinValue checks.
            Minimum (Anything): Minimum allowed Value for the MinValue check.
            Message: Message to display if the MinValue check fails
            Required (bool): If Required is true than Minimun can not be null. Default Value is true;
  
        MaxValue (object): Omit field to ignore MaxValue checks.
            Maximum (Anything): Maximum allowed Value for the MaxValue check.
            Message: Message to display if the MaxValue check fails
            Required (bool): If Required is true than Maximum can not be null. Default Value is true;
    */

    /* Usage Example
    TestAs: "DateTime",
    MessageChaining: false,
    Required: "Wager is a required value",
    DigitOnly: "Wager must be a numeric value",
    MinValue: {
        Minimum: 0,
        Message: "Wager needs to be higher than 0"
    },
    MaxValue: {
        Maximum: 100,
        Message: "Wager needs to be lower than 100"
    }
    */

    ValidationExpressionBuilder = function () {
        this.optionsObj = {};

        this.Required = function (failMsg) {
            this.optionsObj.Required = failMsg;
            return this;
        };

        this.DigitOnly = function (failMsg) {
            this.optionsObj.DigitOnly = failMsg;
            return this;
        };

        this.MinValue = function (min, failMsg) {
            this.optionsObj.MinValue = { Minimum: min, Message: failMsg };
            return this;
        };

        this.MaxValue = function (max, failMsg) {
            this.optionsObj.MaxValue = { Maximum: max, Message: failMsg };
            return this;
        };

        this.MessageChaining = function (allowChaining) {
            this.optionsObj.MessageChaining = allowChaining;
            return this;
        };

        this.TestAs = function (testAs) {
            this.optionsObj.TestAs = testAs;
            return this;
        };

        this.WholeNumberOnly = function (failMsg) {
            this.optionsObj.WholeNumberOnly = failMsg;
            return this;
        };

        this.Format = function (format, failMsg) {
            this.optionsObj.Format = { Type: format, Message: failMsg };
            return this;
        };

        this.Build = function () {
            return this.optionsObj;
        };
    };
}
